<template>
  <button
    type="button"
    :disabled="disabled"
    :class="['btn text', { disabled: disabled }]"
    @click="emit('click')"
  >
    {{ text }}
    <slot />
  </button>
</template>

<script lang="ts" setup>
const emit = defineEmits(['click'])

defineProps({
  text: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: undefined
  }
})

</script>

<style lang="scss" scoped>
.btn.text {
  background-color: transparent;
  color: var(--text-primary);
  border: none;
  cursor: pointer;
}

.btn.disabled {
  cursor: not-allowed;
  color: inherit;
}
</style>
